import { useContext, useRef, useState } from 'react';
// import projectService from '../.././../services/project';
import { useSlideEditorContext } from '../../../providers/SlideEditorProvider';
import Konva from 'konva';
import MediaWidget from '../../../components/common/media-widget/MediaWidget';

import {
  ADD_SLIDE,
  REMOVE_SLIDE,
  SAVE_SLIDE,
  SET_ACTIVE_SLIDE,
  SET_DELETE_MODAL,
  SET_SLIDES,
  SET_UPDATE_BACKGROUND
} from '../../../reducers/SlideEditorReducer';
// import pitchDeckService from '../../../services/pitchdeck';
// import { useNavigate, useParams } from 'react-router-dom';
import NPSpinner from '../../../components/base/NPSpinner';
// import { getSasTokenAsync } from '../../../data/storage';
// import { BlobServiceClient } from '@azure/storage-blob';
import useTextEditor from '../../../hooks/useTextEditor';
import ModalStyle from './ModalStyle';
import SlideView from './SlideViewer';
import SlideEditor from './SlideEditor';
import ToastWrapper from '../../../components/Toast';
import ModalDelete from './ModalButtons/ModalDelete';
import useImageEditor from 'hooks/useImageEditor';
import SlideNavBar from '../SlideNavBar';
import slidesService from 'services/slide';
import { SlideData, SlidesResponse } from '../index';
import { UserContext } from 'contexts/UserContext';
import { useNavigate } from 'react-router-dom';
import ModalMoveForward from './ModalButtons/ModalMoveForward';
import ModalMoveBackward from './ModalButtons/ModalMoveBackward';
import useZindexEditor from 'hooks/useZIndexEditor';

export interface IProps {
  layerRef: React.RefObject<Konva.Layer>;
  initSlides: SlideData[];
}

export interface ImageData {
  konvaImage: Konva.Image;
  url: string;
}

const SlideTemplateEditor = ({ layerRef, initSlides }: IProps) => {
  const [showModalStyle, setShowModalStyle] = useState(false);
  const textsRef = useRef<Konva.Text[]>([]);
  const transformerListRef = useRef<Konva.Transformer[]>([]);
  const {
    slideEditMode,
    slideEditorDispatch,
    uploading,
    slides,
    activeSlideIndex,
    showDeleteModal,
    pitchDeckData,
    projectData
  } = useSlideEditorContext();
  const slideCurrent = slides[activeSlideIndex];
  const [textActive, setTextActive] = useState(0);
  const [isText, setIsText] = useState(false);
  const [locationTextNode, setLocationTextNode] = useState({ x: 0, y: 0 });
  const [locationImageNode, setLocationImageNode] = useState({ x: 0, y: 0 });
  const [bgImagePosition, setbgImagePosition] = useState({ x: 0, y: 0 });
  const [backgroundScale, setbgImageScale] = useState(1);
  const imagesRef = useRef<ImageData[]>([]);
  const {
    uploadingImage,
    handleUploadImage,
    handleClearImages,
    handleDeleteActiveImage,
    addImageOnSlide,
    setImageActive,
    imageActive
  } = useImageEditor({
    layerRef,
    isText,
    setLocationImageNode,
    setIsText,
    imagesRef,
    setShowModalStyle,
    setTextActive,
    transformerListRef
  });
  const { addTextString, addTextOnSlide } = useTextEditor({
    layerRef,
    setLocationTextNode,
    setShowModalStyle,
    textsRef,
    transformerListRef,
    setTextActive,
    setIsText,
    setImageActive
  });
  const { handleMoveUpDown } = useZindexEditor({
    layerRef,
    textsRef,
    textActive,
    imagesRef,
    imageActive
  });
  const [messageToast, setMessgeToast] = useState('');
  const [showToast, setShowToast] = useState(false);
  const { user } = useContext(UserContext);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleChangeSize = (value: string) => {
    textsRef.current[textActive].fontSize(Number(value));
    textsRef.current[textActive].getLayer()?.batchDraw();
  };

  const handleChangeColor = (value: string) => {
    textsRef.current[textActive].fill(value);
    textsRef.current[textActive].getLayer()?.batchDraw();
  };

  const handleChangeAlignment = (value: string) => {
    textsRef.current[textActive].align(value);
    textsRef.current[textActive].getLayer()?.batchDraw();
  };

  const handleChangeFont = (value: string) => {
    textsRef.current[textActive].fontFamily(value);
    textsRef.current[textActive].getLayer()?.batchDraw();
  };

  const handleChangeStyle = (value: string) => {
    textsRef.current[textActive].fontStyle(value);
    textsRef.current[textActive].getLayer()?.batchDraw();
  };

  const handleClearText = () => {
    if (layerRef.current) {
      const texts = layerRef.current.find('Text');
      texts.forEach(textNode => {
        const transformer = transformerListRef.current.find(
          tr => tr.nodes()[0] === textNode
        );
        if (transformer) {
          transformer.destroy();
        }
        textNode.destroy();
      });
      textsRef.current = [];
      transformerListRef.current = [];
      layerRef.current.draw();
    }
  };

  const handleClearSlide = () => {
    if (transformerListRef.current[textActive]) {
      transformerListRef.current[textActive].detach();
      transformerListRef.current[textActive].hide();
    }
    slideEditorDispatch({ type: SET_DELETE_MODAL, payload: false });
    handleClearImages();
    handleClearText();
    setMessgeToast('clear slide successfull');
    setShowToast(true);
  };

  const handleResetAll = async () => {
    try {
      setIsLoading(true);
      slideEditorDispatch({ type: SET_UPDATE_BACKGROUND, payload: false });
      if (transformerListRef.current[textActive]) {
        transformerListRef.current[textActive].detach();
        transformerListRef.current[textActive].hide();
      }
      slideEditorDispatch({ type: SET_DELETE_MODAL, payload: false });
      handleClearImages();
      handleClearText();
      if (!pitchDeckData || !projectData) return;

      const slides: SlidesResponse[] =
        await slidesService.getAllSlideByPitchdeckId(pitchDeckData.pitchDeckId);

      // off all slide
      slides.forEach(async slide => {
        const slideUpdateData = {
          PitchDeckId: pitchDeckData.pitchDeckId,
          SlideId: slide.slideId,
          IsActive: false
        };
        await slidesService.updateSlide(slideUpdateData);
      });

      //add initSlides
      const slidesResponse: SlidesResponse[] =
        await slidesService.createMultipleSlides(initSlides);
      const filteredSlides = slidesResponse
        .filter(slide => slide.isActive)
        .map(slide => ({
          ...JSON.parse(slide.slideContent),
          slideId: slide.slideId
        }));

      slideEditorDispatch({ type: SET_SLIDES, payload: filteredSlides });
      setMessgeToast('reset successfully');
      setShowToast(true);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      navigate('/pages/error/400');
    }
  };

  const handleAddSlide = async () => {
    try {
      setIsLoading(true);
      slideEditorDispatch({ type: SET_UPDATE_BACKGROUND, payload: false });
      slideEditorDispatch({ type: SET_DELETE_MODAL, payload: false });
      if (!pitchDeckData) return;

      const slideContent = {
        background:
          'https://nupitchstorage.blob.core.windows.net/nupitch-test-blob-container/nupitch_default_slide_background.jpg',
        images: [],
        texts: [
          {
            x: 20,
            y: 20,
            fontStyle: 'bold',
            size: 24,
            color: '#ffff',
            text: 'New slide',
            roration: 0,
            alignment: 'center',
            font: 'Arial',
            width: 560,
            zIndex: 0
          }
        ]
      };
      const newSlide: SlideData[] = [
        {
          PitchDeckId: pitchDeckData?.pitchDeckId,
          SlideTitle: 'New Page',
          SlideOrder: slides.length,
          SlideContent: JSON.stringify(slideContent),
          isActive: true
        }
      ];

      const response: SlidesResponse[] =
        await slidesService.createMultipleSlides(newSlide);
      const slide = {
        slideId: response[0].slideId,
        ...slideContent,
        backgroundPosition: { x: 0, y: 0 }
      };
      handleClearText();
      handleClearImages();
      slideEditorDispatch({ type: ADD_SLIDE, payload: slide });
      slideEditorDispatch({ type: SET_ACTIVE_SLIDE, payload: slides.length });
      setShowToast(true);
      setMessgeToast('add slide successfully');
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      navigate('/pages/error/400');
    }
  };

  const handleRemoveSlide = async () => {
    try {
      setIsLoading(true);
      slideEditorDispatch({ type: SET_UPDATE_BACKGROUND, payload: false });
      slideEditorDispatch({ type: SET_DELETE_MODAL, payload: false });
      if (slides.length <= 1) {
        setMessgeToast('can not delete');
        setShowToast(true);
        setIsLoading(false);
        return;
      }
      handleClearText();
      handleClearImages();
      const slideCurrentContext = slides[activeSlideIndex];
      const slideContent = {
        background: slideCurrentContext.background,
        images: slideCurrentContext.images,
        texts: slideCurrentContext.texts
      };

      if (!pitchDeckData) return;
      const response: SlidesResponse[] =
        await slidesService.getAllSlideByPitchdeckId(pitchDeckData.pitchDeckId);

      const slideCurrentData: SlidesResponse | undefined = response.find(
        slide => slide.slideId === slideCurrentContext.slideId
      );
      if (!slideCurrentData) return;
      const slideUpdateData = {
        SlideId: slideCurrentData.slideId,
        PitchDeckId: pitchDeckData?.pitchDeckId,
        ContentInnerHtml: slideCurrentData.contentInnerHtml,
        SlideTitle: slideCurrentData.slideTitle,
        SlideContent: JSON.stringify(slideContent),
        SlideNotes: slideCurrentData.slideNotes,
        SlideType: slideCurrentData.slideType,
        SlideBackgoundImage: slideCurrentData.slideBackgoundImage,
        SlideBackgroudVideo: slideCurrentData.slideBackgroudVideo,
        IsActive: false, // convert false
        SlideOrder: slideCurrentData.slideOrder,
        TrackingCode: slideCurrentData.trackingCode,
        TrackingSnippet: slideCurrentData.trackingSnippet,
        CreatedDate: slideCurrentData.createdDate,
        CreatedBy: slideCurrentData.createdBy,
        ModifiedDate: new Date().toISOString(),
        ModifiedBy: user?.userId || '',
        DeletedDate: slideCurrentData.deletedDate,
        DeletedBy: slideCurrentData.deletedBy
      };
      await slidesService.updateSlide(slideUpdateData);

      slideEditorDispatch({ type: REMOVE_SLIDE, payload: activeSlideIndex });
      setShowToast(true);
      setMessgeToast('remove slide successfully');
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      navigate('/pages/error/400');
    }
  };

  const handleDeleteActiveText = () => {
    if (textActive !== null && textsRef.current[textActive]) {
      setShowModalStyle(false);
      const transformer = transformerListRef.current[textActive];
      if (transformer) {
        transformer.detach();
        transformer.destroy();
        transformerListRef.current.splice(textActive, 1);
      }

      const textNode = textsRef.current[textActive];
      textNode.destroy();
      textsRef.current.splice(textActive, 1);

      slideEditorDispatch({ type: SET_DELETE_MODAL, payload: false });
    }
  };

  const isNotImageDestroyed = (konvaImage: Konva.Image) => {
    return konvaImage.getLayer();
  };

  const handleSaveSlide = async () => {
    if (!slideCurrent) return;

    const savedImagesData = imagesRef.current
      .filter(({ konvaImage }) => isNotImageDestroyed(konvaImage))
      .map(el => {
        return {
          x: el.konvaImage.x(),
          y: el.konvaImage.y(),
          zIndex: el.konvaImage.getZIndex(),
          width: el.konvaImage.width(),
          height: el.konvaImage.height(),
          url: el.url,
          roration: el.konvaImage.rotation()
        };
      });

    const savedTextData = textsRef.current.map(text => {
      return {
        x: text.x(),
        y: text.y(),
        zIndex: text.getZIndex(),
        text: text.text(),
        size: text.fontSize(),
        fontStyle: text.fontStyle(),
        color: text.fill(),
        roration: text.rotation(),
        font: text.fontFamily(),
        alignment: text.align(),
        width: text.width()
      };
    });

    if (!pitchDeckData) return;
    const slideCurrentContext = slides[activeSlideIndex];
    const response: SlidesResponse[] =
      await slidesService.getAllSlideByPitchdeckId(pitchDeckData.pitchDeckId);
    const slideCurrentData: SlidesResponse | undefined = response.find(
      slide => slide.slideId === slideCurrentContext.slideId
    );

    const savedSlide = {
      slideId: slideCurrentContext.slideId,
      background: slideCurrent.background,
      backgroundScale: backgroundScale,
      backgroundPosition: bgImagePosition,
      images: savedImagesData,
      texts: savedTextData
    };

    slideEditorDispatch({ type: SAVE_SLIDE, payload: savedSlide });

    if (!slideCurrentData) return;
    const slideUpdateData = {
      SlideId: slideCurrentData.slideId,
      PitchDeckId: pitchDeckData?.pitchDeckId,
      ContentInnerHtml: slideCurrentData.contentInnerHtml,
      SlideTitle: slideCurrentData.slideTitle,
      SlideContent: JSON.stringify(savedSlide),
      SlideNotes: slideCurrentData.slideNotes,
      SlideType: slideCurrentData.slideType,
      SlideBackgoundImage: slideCurrentData.slideBackgoundImage,
      SlideBackgroudVideo: slideCurrentData.slideBackgroudVideo,
      IsActive: true,
      SlideOrder: slideCurrentData.slideOrder,
      TrackingCode: slideCurrentData.trackingCode,
      TrackingSnippet: slideCurrentData.trackingSnippet,
      CreatedDate: slideCurrentData.createdDate,
      CreatedBy: slideCurrentData.createdBy,
      ModifiedDate: new Date().toISOString(),
      ModifiedBy: user?.userId || '',
      DeletedDate: slideCurrentData.deletedDate,
      DeletedBy: slideCurrentData.deletedBy
    };

    await slidesService.updateSlide(slideUpdateData);
  };

  if (slides.length === 0) {
    return <NPSpinner />;
  }

  return (
    <div>
      <SlideNavBar handleSaveSlide={handleSaveSlide} />
      <div>
        {!slideEditMode ? (
          <SlideView
            imagesRef={imagesRef}
            textsRef={textsRef}
            transformerListRef={transformerListRef}
          />
        ) : (
          <SlideEditor
            layerRef={layerRef}
            setShowModalStyle={setShowModalStyle}
            addTextOnSlide={addTextOnSlide}
            addImageOnSlide={addImageOnSlide}
            bgImagePosition={bgImagePosition}
            setbgImagePosition={setbgImagePosition}
            setbgImageScale={setbgImageScale}
          />
        )}
        {slideEditMode && (
          <MediaWidget
            slideActiveId={''}
            onAddSlide={handleAddSlide}
            onRemoveSlide={handleRemoveSlide}
            onAddTextString={addTextString}
            onAddShape={() => {}}
            onAddImage={handleUploadImage}
            onAddBackground={() => {}}
            onClearSlide={handleClearSlide}
            onResetAll={handleResetAll}
          />
        )}
        {showModalStyle && (
          <ModalStyle
            handleChangeAlignment={handleChangeAlignment}
            handleChangeFont={handleChangeFont}
            handleChangeColor={handleChangeColor}
            handleChangeSize={handleChangeSize}
            handleChangeStyle={handleChangeStyle}
            locationTextNode={locationTextNode}
            setShowModalStyle={setShowModalStyle}
          />
        )}
        {showDeleteModal && (
          <ModalDelete
            isText={isText}
            locationTextNode={locationTextNode}
            locationImageNode={locationImageNode}
            handleDeleteActiveText={handleDeleteActiveText}
            handleDeteleActiveImage={handleDeleteActiveImage}
          />
        )}
        {showDeleteModal && (
          <>
            <ModalMoveForward
              locationImageNode={isText ? locationTextNode : locationImageNode}
              handleMoveUpDown={handleMoveUpDown}
            />
            <ModalMoveBackward
              locationImageNode={isText ? locationTextNode : locationImageNode}
              handleMoveUpDown={handleMoveUpDown}
            />
          </>
        )}
        <ToastWrapper
          showToast={showToast}
          message={messageToast}
          setShowToast={setShowToast}
        />
        {uploading && (
          <div className="position-absolute top-0 start-0 end-0 bottom-0">
            <NPSpinner />
          </div>
        )}
        {isLoading && (
          <div className="position-absolute top-0 start-0 end-0 bottom-0">
            <NPSpinner />
          </div>
        )}
        {uploadingImage && (
          <div className="position-absolute top-0 start-0 end-0 bottom-0">
            <NPSpinner />
          </div>
        )}
      </div>
    </div>
  );
};

export default SlideTemplateEditor;
